import { Breakpoints, styled } from "@volkswagen-onehub/components-core";

export const ContainerMain = styled.div`
  width: 100%;
  max-width: 2560px;
  margin: 0 auto;
  padding: 0 ${(props) => props.theme.size.grid001};

  @media (min-width: ${Breakpoints.b960}px) {
    padding: 0 ${(props) => props.theme.size.grid002};
  }

  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0130};
`;

export const CTAWrapper = styled.div`
  min-width: 200px;

  button, a {
    width: 100%;
    padding: 1rem;
    border-width: 2px;
  }
`;